import classnames from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { color } from '../../../app/theme';
import ImageDisplay from '../ImageDisplay';

const useStyles = makeStyles(
  () => ({
    root: {
      display: 'flex',
      height: 140,
      marginBottom: 12,
    },
    'root--no-height': {
      height: 'auto',
    },
    'root--audio-height': {
      height: '54px',
    },
    content: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 250,
      height: '100%',
      fontSize: 13,
      color: color.$13,
      backgroundColor: color.$8,
      borderRadius: 12,
      marginRight: 30,
      '& > img': {
        width: '100%',
        borderRadius: 12,
      },
      '& > audio': {
        height: '100%',
        maxWidth: '100%',
        borderRadius: 12,
      },
      '& > video': {
        height: '100%',
        maxWidth: '100%',
        borderRadius: 12,
      },
    },
    'content--default': {
      width: '100%',
    },
  }),
  {
    name: 'FilePreview',
  },
);

function FilePreview({ orgIconURL, message }) {
  const classes = useStyles();
  return (
    <div
      className={classnames(classes.root, {
        [classes['root--no-height']]:
          message.contentType === 'application/x-image' && !!message.data.url,
        [classes['root--audio-height']]:
          message.contentType === 'application/x-audio',
      })}
    >
      <ImageDisplay
        style={{ objectFit: 'contain', borderRadius: '50%', marginRight: 12 }}
        src={orgIconURL}
        width={44}
        height={44}
      />
      <div
        className={classnames(classes.content, {
          [classes['content--default']]: message.data.url === '',
        })}
      >
        {message.contentType === 'application/x-image' && (
          <img src={message.data.url} alt={message.data.name} />
        )}
        {message.contentType === 'application/x-video' && (
          <video src={message.data.url} controls>
            <track kind="captions" />
          </video>
        )}
        {message.contentType === 'application/x-audio' && (
          <audio src={message.data.url} controls>
            <track kind="captions" />
          </audio>
        )}
      </div>
    </div>
  );
}

export default FilePreview;
